// extracted by mini-css-extract-plugin
export default {"tradeCryptoCard":"TradeCrypto_tradeCryptoCard__3u0PH","button":"TradeCrypto_button__Lx6nh"};